import FrontPageEnum from '../enumerators/front-page.enum'

export default class AnimationService {
    constructor() {
        AnimationService.scrollReveal()
    }

    static removeHeaderAnimatedClass() {
        if ($(FrontPageEnum.NAVBAR).hasClass('navbar--onscroll')) {
            $(FrontPageEnum.BODY).removeClass('hp-header-animated')
        }

        if ($(FrontPageEnum.BODY).hasClass('hp-header-animated')) {
            setTimeout(() => {
                $(FrontPageEnum.BODY).removeClass('hp-header-animated')
            }, 4000)
        }
    }

    static scrollReveal() {
        const ratio = 0.25
        const options = {
            root: null,
            rootMargin: '-50px',
            threshold: ratio,
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach((e) => {
                if (e.intersectionRatio >= ratio) {
                    const revealAction = e.target.getAttribute('data-reveal')
                    if ('clip' === revealAction) {
                        AnimationService.clipPathElement(e.target)
                    } else {
                        $(e.target).addClass('is-loaded')
                    }
                    observer.unobserve(e.target)
                }
            })
        }

        const observer = new IntersectionObserver(handleIntersect, options)

        document.querySelectorAll(FrontPageEnum.REVEAL_ELEMENT).forEach((el) => {
            observer.observe(el)
        })
    }
}
